export default "__VITE_ASSET__CgrQLRJQ__"